import arrowLink from '../../../assets/images/arrow-link.svg';
import styled from '@emotion/styled';

export const MultipleAccountsContainer = styled.div`
  width: 100%;
  color: rgba(55, 82, 180, 1);
  a {
    display: block;
    width: 100%;
    padding: 18px 0;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    text-align: left;
    border-bottom: 1px solid rgba(226, 226, 226, 1);
    background: url(${arrowLink}) right center no-repeat;
    &:hover {
      text-decoration: underline;
    }
    &:last-of-type {
      border: none;
    }
  }
`


// WEBPACK FOOTER //
// ./src/modules/app/components/MultipleAccountsContainer.jsx